import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Observable, Subject } from "rxjs";
import { LanguagesService } from "@ubisolutions/base";
import { TranslatePipe } from "@ngx-translate/core";
import { UserSettingsService } from "@shared/business/services/user-settings.service";

@Component({
    selector: "app-language-selector",
    templateUrl: "./language-selector.component.html",
    styleUrls: ["./language-selector.component.scss"],
    imports: [
        AsyncPipe,
        MatMenuModule,
        MatButtonModule,
        TranslatePipe,
        MatIconModule,
        MatTooltipModule,
    ],
})
export class LanguageSelectorComponent {
    private languagesService = inject(LanguagesService);
    private userSettingsService = inject(UserSettingsService);

    locales$?: Observable<string[]> = this.languagesService.getAvailableLocales();

    currentLanguage$: Subject<string> = this.languagesService.currentLang$;

    setDefaultLanguage(locale: string): void {
        this.languagesService.setLanguage(locale);
        this.userSettingsService.setLanguage(locale).subscribe();
    }
}
